
function Box({ size }) {
    return <div style={{ width: '100%', height: size }}></div>
}

export default Box;
